'use client';

import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import { GamesFilter } from '../../../../GamesFilter/GamesFilter';
import { useGamesList } from '../../../context/GamesListProvider/GamesListProvider';
import { LayoutSwitcher } from '../LayoutSwitcher/LayoutSwitcher';

type ViewControlsProps = ComponentProps<'div'>;

function ViewControls({ className, ...props }: ViewControlsProps) {
  const { availableGameProviders, layout, toggleLayout } = useGamesList();
  return (
    <div className={twMerge('flex items-center gap-2', className)} data-track-container="Actions" {...props}>
      <LayoutSwitcher isGrid={layout === 'grid'} onLayoutChange={toggleLayout} />
      <GamesFilter gameProviders={availableGameProviders} />
    </div>
  );
}

export { ViewControls };
